import { useEffect } from 'react'
import { useEnvironment } from 'contexts/environment'
import Bugsnag from '@bugsnag/browser'
import BugsnagReact from '@bugsnag/plugin-react'
import { local } from 'utilities/storage'
import { getData } from 'utilities/jwt'

const BugsnagReporter = () => {
    const {
        integrations,
        environment
    } = useEnvironment()

    useEffect(() => {
        if(!!integrations?.bugsnagApiKey && !!environment?.stage && environment?.stage !== 'local') {
            Bugsnag.start({
                plugins: [new BugsnagReact()],
                apiKey: integrations.bugsnagApiKey,
                releaseStage: environment.stage,
                ...(environment.commit ? { appVersion: environment.commit.slice(0, 8) } : null),

                onError: event => {
                    const token = getData(local.get('accessToken'))

                    event.setUser(token.sub, token.email, `${token.given_name} ${token.family_name}`)

                    const customer = { id: token.organizationId }
                    const key = global.location.hostname.split('.')[0]

                    if(key !== 'localhost' && !global.location.hostname.endsWith('.herokuapp.com')) {
                        customer.key = key
                    }

                    event.addMetadata('customer', customer)
                }
            })
        }
    }, [integrations, environment])

    return null
}

export default BugsnagReporter